var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2200",
    "data-name": "Grupo 2200",
    transform: "translate(-24.638 -334.638)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_891",
    "data-name": "Ret\\xE2ngulo 891",
    width: 60,
    height: 60,
    rx: 10,
    transform: "translate(24.638 334.638)",
    fill: "#b895ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1738",
    "data-name": "Grupo 1738",
    transform: "translate(36.96 348.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1594",
    "data-name": "Grupo 1594",
    transform: "translate(6.555 22.309)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1593",
    "data-name": "Grupo 1593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310",
    "data-name": "Caminho 310",
    d: "M950.44,449.318a11.429,11.429,0,0,1-11.324-9.583,1.277,1.277,0,0,1,2.52-.415,8.928,8.928,0,0,0,17.607,0,1.278,1.278,0,0,1,2.522.415A11.429,11.429,0,0,1,950.44,449.318Z",
    transform: "translate(-939.099 -438.25)",
    fill: "#b895ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1595",
    "data-name": "Grupo 1595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311",
    "data-name": "Caminho 311",
    d: "M953.146,447.3a1.277,1.277,0,0,1-.649-.175l-16.619-9.791a1.277,1.277,0,0,1,0-2.2l16.619-9.81a1.274,1.274,0,0,1,1.3,0l16.62,9.81a1.275,1.275,0,0,1,0,2.2l-16.62,9.791A1.281,1.281,0,0,1,953.146,447.3Zm-14.1-11.07,14.1,8.311,14.106-8.311-14.106-8.323Z",
    transform: "translate(-935.249 -425.149)",
    fill: "#b895ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1596",
    "data-name": "Grupo 1596",
    transform: "translate(4.428 6.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312",
    "data-name": "Caminho 312",
    d: "M939.129,436.408a1.276,1.276,0,0,1-.651-2.375l8.514-5.023a1.276,1.276,0,1,1,1.3,2.2l-8.514,5.023A1.259,1.259,0,0,1,939.129,436.408Z",
    transform: "translate(-937.849 -428.829)",
    fill: "#b895ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1597",
    "data-name": "Grupo 1597",
    transform: "translate(4.429 11.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313",
    "data-name": "Caminho 313",
    d: "M939.144,441.571a1.278,1.278,0,0,1-1.277-1.274l-.017-7.237a1.278,1.278,0,0,1,1.274-1.281h0a1.278,1.278,0,0,1,1.277,1.274l.017,7.237a1.277,1.277,0,0,1-1.274,1.28Z",
    transform: "translate(-937.85 -431.78)",
    fill: "#b895ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.521e8488d170d4fef07efe0ecc3d5f26.svg";
export { ForwardRef as ReactComponent };